module.exports = __webpack_public_path__ + "files/25c4c3abbc0d0789cd84719151779fc8.png";